module.exports = __webpack_public_path__ + "static/media/logo-responda-aqui-preta-nav.164d9832.png";